<button
  class="btn-back btn--ghost"
  [class.btn-back--link]="variant === 'link'"
  type="button"
  (click)="goBack()">
  <i class="feather icon-chevron-left btn-back__chevron" aria-hidden="true"></i>
  <span *ngIf="text">{{ text }}</span>
  <span *ngIf="!text">{{ 'ADCustomerCustomize.Back' | translate }}</span>
</button>


